function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M802.5,2837.9c219,36,444,54,663,54c12,0,24,0,36,0c234-3,468-24,702-66l0,0c171-33,339-198,375-369c42-210,63-426,63-636 s-21-426-63-636c-36-168-204-333-375-366c-231-42-468-66-702-66c-234-3-468,15-702,54c-171,30-342,195-378,369 c-42,216-63,432-63,648s21,432,63,651C460.5,2642.9,628.5,2807.9,802.5,2837.9z M631.5,1214.9c18-87,120-189,207-204 c210-33,420-51,630-51c12,0,24,0,36,0c222,3,444,24,663,63c87,18,192,117,207,201c39,198,57,399,57,597s-18,399-57,594 c-18,84-120,186-207,204c-219,39-444,63-663,63c-222,3-444-15-663-51c-87-15-189-117-207-201c-39-201-60-408-60-609 S592.5,1415.9,631.5,1214.9z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1027.5,2393.9c21,18,45,27,72,27s57-12,78-33c78-84,204-150,348-180c18-3,33-6,51-9c51,204,198,375,330,342 s201-216,156-420v-3c0-3,0-6-3-9l0,0c-9-30-27-54-57-69c-147-66-330-81-519-42c-186,39-351,126-459,243 C982.5,2288.9,985.5,2354.9,1027.5,2393.9z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1810.5,1532.9l-36,42c-39,45-33,111,12,147c21,18,45,24,69,24c30,0,60-12,81-36l36-42l42,36c21,18,45,24,69,24 c30,0,60-12,81-36c39-45,33-111-12-147l-42-36l36-42c39-45,33-111-12-147c-45-39-111-33-147,12l-36,42l-42-36c-45-39-111-33-147,12 c-39,45-33,111,12,147L1810.5,1532.9z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M916.5,1532.9l-36,42c-39,45-33,111,12,147c21,18,45,24,69,24c30,0,60-12,81-36l36-42l42,36c21,18,45,24,69,24 c30,0,60-12,81-36c39-45,33-111-12-147l-42-36l36-42c39-45,33-111-12-147c-45-39-111-33-147,12l-36,42l-42-36c-45-39-111-33-147,12 c-39,45-33,111,12,147L916.5,1532.9z"
});

var SvgDeath = function SvgDeath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 464 3000 2624.8",
    enableBackground: "new 0 464 3000 2624.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDeath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/death.47728000.svg";
export { ForwardRef as ReactComponent };